import { getRequestConfig, withMakeRequest } from '~/api';
import Request from '~/api/Request.ts';
import {
  BillingInfoData,
  BillingUsageData,
  GetCustomerPortalRequest,
  GetCustomerPortalResponse,
  GetPricingTableRequest,
  GetPricingTableResponse,
  GetSubscriptionsRequest,
  GetSubscriptionsResponse,
  SubscriptionData
} from '~/api/types/billingData.ts';

const getSubscriptions: (
  request: GetSubscriptionsRequest
) => Promise<SubscriptionData[]> = withMakeRequest(
  async ({ workspaceId }: GetSubscriptionsRequest) =>
    await Request.getInstance().get(
      `/workspaces/${workspaceId}/billing/subscriptions`,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data: GetSubscriptionsResponse) => data.subscriptions
);

const getPricingTable: (
  request: GetPricingTableRequest
) => Promise<GetPricingTableResponse> = withMakeRequest(
  async ({ workspaceId }: GetSubscriptionsRequest) =>
    await Request.getInstance().get(
      `/workspaces/${workspaceId}/billing/pricing-table`,
      getRequestConfig({ addEnvDomain: true })
    )
);

const getCustomerPortal: (
  request: GetCustomerPortalRequest
) => Promise<GetCustomerPortalResponse> = withMakeRequest(
  async ({ workspaceId: _ }: GetCustomerPortalRequest) =>
    await Request.getInstance().get(
      `/workspaces:this/billing/customer-portal`,
      getRequestConfig({ addEnvDomain: true })
    )
);

type GetBillingInfoRequest = {
  showAddonsOnly?: boolean;
};

type GetBillingInfoResponse = {
  billingInfo: BillingInfoData;
};

const getWorkspaceBillingInfo: (
  request?: GetBillingInfoRequest
) => Promise<BillingInfoData> = withMakeRequest(
  async (request?: GetBillingInfoRequest) =>
    await Request.getInstance().get(
      `/workspaces:this/billing:info${request?.showAddonsOnly ? '?only_addons=true' : ''}`,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data: GetBillingInfoResponse) => data.billingInfo
);

const getWorkspaceBillingUsage: () => Promise<BillingUsageData> =
  withMakeRequest(
    async () =>
      await Request.getInstance().get(
        `/workspaces:this/billing:product-usage`,
        getRequestConfig({ addEnvDomain: true })
      )
  );

type AddProductToSubscriptionRequest = {
  productName: string;
};

const addProductToSubscription: (
  request: AddProductToSubscriptionRequest
) => Promise<BillingUsageData> = withMakeRequest(
  async ({ productName }: AddProductToSubscriptionRequest) =>
    await Request.getInstance().post(
      `/workspaces:this/billing/subscriptions:add`,
      { productName },
      getRequestConfig({ addEnvDomain: true })
    )
);

export {
  getSubscriptions,
  getPricingTable,
  getCustomerPortal,
  getWorkspaceBillingInfo,
  getWorkspaceBillingUsage,
  addProductToSubscription
};
